<div class="us-right-row">
    <label class="flex-fill">{{CHECKSHEETSETTINGDIALOG.TIME_CHANGE_PAGE}}</label>
    <div class="us-right-item us-right-control">
        <caremoni-textbox [inputValue]="timeChangePage"[inputParams]="inputParams"
            (onKeyDown)="onInputKeyDown($event)" (focusout)="onFocusOutInput($event)"
            (inputValueChange)="onChangeSettingTime($event)"
            [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="0" [ydpad]="0">
        </caremoni-textbox>
        <label class="pl-2 l-h-40">秒</label>
    </div>
</div>
<div class="us-right-row">
    <label class="flex-fill">{{CHECKSHEETSETTINGDIALOG.MARQUEE_SPEED}}</label>
    <div class="us-right-item us-right-control">
        <caremoni-tv-select [id]="'marquee-speed-select'" [options]="marqueeSpeedOptions"
            [selectedValue]="marqueeSpeedRate" (valueChange)="onChangeMarqueeSpeed($event)"
            [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="0" [ydpad]="1">
        </caremoni-tv-select>
    </div>
</div>
<div class="us-right-row" *ngIf="isShowFlashing">
    <label class="flex-fill">{{CHECKSHEETSETTINGDIALOG.FLASHING_SWITCHING}}</label>
    <div class="us-right-item us-right-control">
        <caremoni-switch-button [checked]="isFlashingMoshiokuri" (onClick)="onChangeFlashingType()"
            [dpad]="DpadZoneType.TV_USER_SETTINGS_RIGHT" [scaledpad]="1.1" [xdpad]="0" [ydpad]="2">
        </caremoni-switch-button>
    </div>
</div>